var wordsLengthLessThen = function wordsLengthLessThen(length, text) {
  if (text === void 0) {
    text = '';
  }
  var wordsArr = text.trim().split(/\s/);
  return wordsArr.every(function (word) {
    return word.length < length;
  });
};
module.exports = wordsLengthLessThen;